var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMenuCoach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/messages-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3134 11.22L12.5734 13.3267C12.6401 13.88 12.0467 14.2667 11.5734 13.98L9.26672 12.6067C9.10672 12.5133 9.06672 12.3133 9.15338 12.1533C9.48672 11.54 9.66672 10.8467 9.66672 10.1533C9.66672 7.71334 7.57338 5.72667 5.00005 5.72667C4.47338 5.72667 3.96005 5.80667 3.48005 5.96667C3.23338 6.04667 2.99338 5.82 3.05338 5.56667C3.66005 3.14 5.99339 1.33334 8.78005 1.33334C12.0334 1.33334 14.6667 3.79334 14.6667 6.82667C14.6667 8.62667 13.7401 10.22 12.3134 11.22Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.66671 10.1533C8.66671 10.9467 8.37337 11.68 7.88004 12.26C7.22004 13.06 6.17337 13.5733 5.00004 13.5733L3.26004 14.6067C2.96671 14.7867 2.59337 14.54 2.63337 14.2L2.80004 12.8867C1.90671 12.2667 1.33337 11.2733 1.33337 10.1533C1.33337 8.98 1.96004 7.94667 2.92004 7.33334C3.51337 6.94667 4.22671 6.72667 5.00004 6.72667C7.02671 6.72667 8.66671 8.26 8.66671 10.1533Z",
    fill: "#171717"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMenuCoach);
export default __webpack_public_path__ + "static/media/course_menu_coach.4ea72029c19817ad92291610b6a50102.svg";
export { ForwardRef as ReactComponent };